import { useTranslations } from '@vocab/react';
import { Alert, Stack, Strong, Text } from 'braid-design-system';
import React, { type FunctionComponent, type PropsWithChildren } from 'react';

import translations from '@seek/rr-caja/src/.vocab';

export const AlertPanel: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="info">
      <Stack space="medium">
        <Text>
          <Strong>{t('error.widget.UnableToLoad')}</Strong>
        </Text>
        <Text>{t('error.widget.UnableToLoadMessage')}</Text>
        {children ? <Text>{children}</Text> : null}
      </Stack>
    </Alert>
  );
};
